window.$ = window.jQuery = require('jquery');
window.moment = require('moment');
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

require('./custom/vendor/bootstrap-datepicker')
require('popper.js');
require('bootstrap/js/dist/util');
require('bootstrap/js/dist/tab');
require('bootstrap/js/dist/modal');
require('bootstrap/js/dist/collapse');

